module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/tile_savethedate-c3d399416624d3f5ed14cbc81e2ea8aa.jpg";